import type { SxProps, Theme } from '@mui/material/styles';
import type { StackProps } from '@mui/material';

export const modalContainerSx: SxProps<Theme> = {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  p: 2,
};

export const closeButtonSx: SxProps<Theme> = {
  position: 'absolute',
  top: 2,
  right: 2,
  zIndex: 1,
};

export const modalCardSx: SxProps<Theme> = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  width: '100%',
  maxWidth: '1054px',
  maxHeight: '100%',
  overflowY: 'auto',
  p: 3,
  outline: 'none',
  backgroundColor: '#08080A',
};

export const activeBoostCardSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  backgroundColor: '#111217',
  flexShrink: 0,
};

export const headerStackSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  mb: 2,
  '@media (max-width: 426px)': {
    flexDirection: 'column',
    gap: 1.5,
    '& > button': {
      width: '100%',
    },
  },
};

export const leftRowSx: SxProps<Theme> = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 2,
};

export const iconBoxSx: SxProps<Theme> = {
  p: 1,
  borderRadius: '6px',
  backgroundColor: '#99A8FF1A',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const titleTextSx: SxProps<Theme> = {
  fontSize: 20,
  fontWeight: 'bold',
};

export const queueSectionStackProps: StackProps = {
  direction: 'column',
  mt: 1,
  gap: 1,
};

export const queueLabelTextSx: SxProps<Theme> = {
  fontSize: 16,
  color: '#CCD4FF',
};

export const queueListStackProps: StackProps = {
  direction: 'column',
  gap: 1.5,
  sx: { maxHeight: 200, overflowY: 'auto' },
};

export const inventoryRowStackProps: StackProps = {
  direction: 'row',
  gap: 1,
  alignItems: 'stretch',
  sx: {
    flexWrap: { xs: 'wrap', md: 'nowrap' },
    '& > *': {
      '@media (max-width: 768px)': {
        flex: '0 0 calc(33.33% - 5.33px)',
      },
      '@media (max-width: 600px)': {
        flex: '0 0 calc(50% - 4px)',
      },
      '@media (max-width: 426px)': {
        flex: '0 0 100%',
      },
    },
  },
};

export const addInventoryCardSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  backgroundColor: '#99A8FF1A',
  opacity: 0.6,
};

export const inventoryWrapperSx: SxProps<Theme> = {
  position: 'relative',
};

export const inventoryBlurOverlaySx: SxProps<Theme> = {
  position: 'absolute',
  inset: 0,
  zIndex: 1,
  backdropFilter: 'blur(50px)',
  borderRadius: '8px',
  border: '1px solid #FFFFFF1A',
};

export const inventoryEmptyCardSx: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 2,
  px: 4,
  py: 3,
  backgroundColor: '#1A1B23',
  border: '1px solid #99A8FF33',
  textAlign: 'center',
  maxWidth: 360,
  width: '100%',
};

export const inventoryEmptyTextSx: SxProps<Theme> = {
  fontSize: 14,
  color: '#CCD4FF',
};

export const infoCardSx: SxProps<Theme> = {
  backgroundColor: '#111217',
  flexShrink: 0,
};

export const infoHeaderStackProps: StackProps = {
  direction: 'row',
  alignItems: 'center',
  gap: 2,
  mb: 2,
};

export const infoTitleTextSx: SxProps<Theme> = {
  fontSize: { xs: 16, md: 18 },
  fontWeight: 'bold',
  color: '#CCD4FF',
};

export const infoBodyTextSx: SxProps<Theme> = {
  fontSize: { xs: 12, md: 14 },
};
